import { InputText } from 'primereact/inputtext'
import styles from './index.module.scss'
import { InputProps } from './input.interface'

export const Input = ({
  label,
  type,
  onChange,
  value,
  size,
  className,
  name,
  placeholder,
  tabIndex,
  required,
  autoFocus,
  maxLength,
  touched,
  isError,
  onBlur,
  errorMessage,
  onKeyDown,
  disabled,
}: InputProps) => {
  return (
    <div className={`${styles.inputBox} ${className}`}>
      {label ? (
        <label>
          {label}
          {required ? <span className={styles.reqText}>*</span> : ''}
        </label>
      ) : (
        ''
      )}
      <InputText
        maxLength={maxLength}
        className={[styles[`${type}`], styles[`${size}`], className].join(' ')}
        type={type}
        onChange={onChange}
        placeholder={placeholder}
        value={value}
        onBlur={onBlur}
        name={name}
        tabIndex={tabIndex || 1}
        autoFocus={autoFocus}
        onKeyDown={onKeyDown}
        disabled={disabled}
      />
      {touched && isError && <p className={styles.errorMsg}>{errorMessage}</p>}
    </div>
  )
}

export default Input
